export const conferenceActionTypes = {
  FETCH_LES_HISTORY_START: 'FETCH_LES_HISTORY_START',
  FETCH_LES_HISTORY_SUCCESS: 'FETCH_LES_HISTORY_SUCCESS',
  FETCH_LES_HISTORY_FAILED: 'FETCH_LES_HISTORY_FAILED',
  TRANSFORM_LES_PROFILE_BY_DISTRICT: 'TRANSFORM_LES_PROFILE_BY_DISTRICT',
};
